import axios from "axios";

export interface PatreonCampaign {
  id: string;
  vanity: string;
  benefits: PatreonBenefit[];
}

export interface PatreonBenefit {
  id: string;
  title: string;
  description: string | null;
}

export const getWorkspacePatreonCampaign = async (
  workspaceId: number,
): Promise<PatreonCampaign> => {
  return (
    await axios.get<PatreonCampaign>(
      `/api/v1/workspaces/${workspaceId}/integrations/patreon/campaign`,
    )
  ).data;
};
